module.exports = __webpack_public_path__ + "img/close1.48d778ee.svg";